// extracted by mini-css-extract-plugin
export default {"container":"fE2ab5","label":"nvTUvu"};